export const SET_M4_REQUEST = 'SET_M4_REQUEST';
export const SET_M4_FAILED = 'SET_M4_FAILED';
export const SET_M4_DECISION_DRIVERS_SUCCESS = 'SET_M4_DECISION_DRIVERS_SUCCESS';
export const SET_M4_SEGMENT_LIST_SUCCESS = 'SET_M4_SEGMENT_LIST_SUCCESS';
export const SET_M4_SEGMENT_DRIVERS_LIST_SUCCESS = 'SET_M4_SEGMENT_DRIVERS_LIST_SUCCESS';
export const SET_M4_SEGMENT_SUCCESS = 'SET_M4_SEGMENT_SUCCESS';
export const SET_M4_COMPETITORS_LIST_SUCCESS = 'SET_M4_COMPETITORS_LIST_SUCCESS';
export const SET_M4_DRIVER_OFFER_SUCCESS = 'SET_M4_DRIVER_OFFER_SUCCESS';
export const CLEAN_M4 = 'CLEAN_M4';
